const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const PendingRetouchTransfersQueryURL: any = {
    QueryPendingRetouchTransfers: Backofficebff + '/v1/pending-retouch-transfers/query',
};
